import { ViewType } from 'src/app/models/server/enums/view-type';
import { Folder } from 'src/app/models/server/folder';

export class DialogAddFolderData {
    public constructor(
        public selectorType: ViewType,
        public folder: Folder
    ) {}
}
